// extracted by mini-css-extract-plugin
export default {"hideTooltip":"T_-z","fadeIn":"U_-z","delay":"V_-z","recommendedSizeTooltip":"W_-z"};